module.exports = __webpack_public_path__ + "img/2.4c06bb76.jpg";